import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

export function Accordion({ items, className }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className={cn("space-y-4", className)}>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          question={item.question}
          answer={item.answer}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? null : index)}
        />
      ))}
    </div>
  );
}

export function AccordionItem({
  question,
  answer,
  isOpen = false,
  onToggle,
}) {
  return (
    <div
      className={cn(
        "border-b border-border",
        "transition-colors duration-300",
        isOpen && "border-gold"
      )}
    >
      <button
        onClick={onToggle}
        className={cn(
          "w-full py-5 flex items-center justify-between gap-4",
          "text-left",
          "group",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2"
        )}
        aria-expanded={isOpen}
      >
        <span
          className={cn(
            "font-serif text-lg font-semibold",
            "transition-colors duration-300",
            "group-hover:text-gold",
            isOpen && "text-gold"
          )}
        >
          {question}
        </span>
        <ChevronDown
          className={cn(
            "w-5 h-5 text-ink-muted flex-shrink-0",
            "transition-transform duration-300",
            isOpen && "rotate-180 text-gold"
          )}
        />
      </button>

      <div
        className={cn(
          "grid transition-all duration-300 ease-in-out",
          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        )}
      >
        <div className="overflow-hidden">
          <p className="pb-5 text-ink-secondary font-body leading-relaxed">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
}
